<app-navigation>
  <main><router-outlet></router-outlet></main>
  <app-footer></app-footer>
</app-navigation>
